export default "__VITE_ASSET__BP4J2lfv__"